import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

const routes: Routes = [
  { path: "", loadChildren: () => import('./componets/home/home.module').then(mod => mod.HomeModule), pathMatch: "full" },
  { path: "services", loadChildren: () => import('./componets/services/services.module').then(mod => mod.ServicesModule) },
  { path: "about", loadChildren: () => import('./componets/about/about.module').then(mod => mod.AboutModule) },
  { path: "Error", loadChildren: () => import('./componets/error/error.module').then(mod => mod.ErrorModule) },
  { path: "**", redirectTo: "/Error" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
